import { catalogLabelMatchesHomeGymCarousel } from '../constants/filterableAssetTypes';
import { assetRecordAssetTypeId } from './homeCarouselAssetMatch';

const GYM_TYPE_IDS = new Set([9]);

function isPlainObject(v: unknown): v is Record<string, unknown> {
  return v !== null && typeof v === 'object' && !Array.isArray(v);
}

function normalizeLabel(label: string): string {
  return label.trim().toLowerCase().replace(/\s+/g, ' ');
}

function assetTypeNameBag(asset: Record<string, unknown>): Set<string> {
  const bag = new Set<string>();
  const add = (raw: unknown) => {
    if (typeof raw === 'string' && raw.trim()) {
      bag.add(normalizeLabel(raw));
    }
  };
  add(asset.asset_type_name);
  add(asset.assetTypeName);
  add(asset.type_name);
  add(asset.type);
  if (typeof asset.asset_type === 'string') {
    add(asset.asset_type);
  }
  if (isPlainObject(asset.asset_type)) {
    add(asset.asset_type.name);
    add(asset.asset_type.label);
    add(asset.asset_type.type_name);
    add(asset.asset_type.title);
  }
  return bag;
}

/** Whether a booking targets a gym / fitness asset (health declaration required). */
export function assetIsGymBooking(asset: Record<string, unknown>): boolean {
  const typeId = assetRecordAssetTypeId(asset);
  if (typeId !== null && GYM_TYPE_IDS.has(typeId)) {
    return true;
  }
  return Array.from(assetTypeNameBag(asset)).some((name) => catalogLabelMatchesHomeGymCarousel(name));
}
